<template>
  <div class="pa-3">
    <v-card style="width: 100%">
      <VueTabulator
        v-if="user !== null"
        ref="tabulator"
        :options="tabulatorOptions"
        v-model="listData"
        class="table-striped table-bordered table-sm"
         style="width: 100%"
      />
    </v-card>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";

export default {
  mixins: [apiCalls],
  props: [ "event", "heightTab" ],
  data() {
    return {
      listData: [],
      user: null,
    };
  },
  computed: {
    tabulatorOptions: function () {
      return {
        layout: "fitColumns",
        height: (this.heightTab !== null && this.heightTab !== undefined) ? this.heightTab : 500,
        placeholder: this.$t("common.no_data_set"),
        resizableColumns: false,
        columns: [
            {
              title: this.$t("page.raceList.event-name"),
              field: "eventName",
              sorter: "string",
              formatter: "textarea",
              minWidth: 150,
              headerFilter: "input",
              headerFilterPlaceholder: " ",
            },
            {
              title: this.$t("page.raceList.event-date"),
              field: "eventDate",
              sorter: "string",
              formatter: "html",
              minWidth: 100,
              headerFilter: "input",
              headerFilterPlaceholder: " ",
            },
            {
              title: this.$t("page.raceList.race-name"),
              field: "raceName",
              sorter: "string",
              formatter: "textarea",
              minWidth: 140,
              headerFilter: "input",
              headerFilterPlaceholder: " ",
            },
            {
              title: this.$t("page.raceList.scoring-mode"),
              field: "scoringMode",
              sorter: "string",
              formatter: "textarea",
              minWidth: 100,
              headerFilter: "input",
              headerFilterPlaceholder: " ",
            },
            {
              title: this.$t("page.raceList.track-length"),
              field: "trackLength",
              sorter: "string",
              formatter: "textarea",
              minWidth: 90,
              headerFilter: "input",
              headerFilterPlaceholder: " ",
            },
            {
              title: this.$t("page.raceList.start-date"),
              field: "startDate",
              sorter: "string",
              formatter: "textarea",
              minWidth: 100,
              headerFilter: "input",
              headerFilterPlaceholder: " ",
            },
            {
              title: this.$t("page.raceList.start-time"),
              field: "startTime",
              sorter: "string",
              formatter: "textarea",
              minWidth: 100,
              headerFilter: "input",
              headerFilterPlaceholder: " ",
            },
            {
              title: this.$t("page.raceList.race-length"),
              field: "raceLength",
              sorter: "string",
              formatter: "textarea",
              widthShrink: 1,
              minWidth: 90,
              headerFilter: "input",
              headerFilterPlaceholder: " ",
            },
            {
              title: this.$t("page.raceList.status"),
              field: "status",
              sorter: "string",
              formatter: function (cell) {
                let value = cell.getValue();
                value = value ? (value.toLowerCase()).replaceAll(' ','-') : value;
                return value ? this.$t(`common.${value}`) : '';
              }.bind(this),
              minWidth: 95,
              headerFilter: "input",
              headerFilterPlaceholder: " ",
            },
            {
              title: this.$t("page.raceList.display-online"),
              field: "displayOnline",
              sorter: "string",
              formatter: function (cell) {
                let value = cell.getValue();
                return value ? this.$t('dashboard.menu.eventDetails.yes') : this.$t('dashboard.menu.eventDetails.no');
              }.bind(this),
              widthShrink: 1,
              minWidth: 70,
              headerFilter: "input",
              headerFilterPlaceholder: " ",
            },
            {
              title: this.$t("page.raceList.action"),
              field: "action",
              sorter: "string",
              formatter: "html",
              cssClass: "text-center",
              minWidth: 55,
              cellClick: function (e, cell) {
                const rowData = cell._cell.row.data;
                this.$router.push({ name: "raceDetails", params: { id : rowData.raceId }});
              }.bind(this),
            },
        ],
      };
    },
  },
  methods: {
    async getUser() {
      const response = await this.api("get", "/api/v1/users/current");
      const { success, message } = response;
      if (success) this.user = message;
    },
    async loadRaceList() {
      await this.getUser();
      if(this.event) {
        const response = await this.api("get", `/api/v1/livelaps/promoter/event/${this.event.id}/races`);
        const { success, message } = response;
        if(success) {
          const { data } = message;
          this.listData = data.map((item) => {
            return {
              ...item,
              raceName: this.$escapeHtml.decode(item.raceName),
              eventName: this.$escapeHtml.decode(this.event.eventName),
              eventDate: this.event.eventDate,
              startDate: item.startDay,
              //displayOnline: item.displayFlag ? 'Yes' : 'No',
              action: "<i class='far fa-pencil-alt'></i>"
            }
          });
        }
      } else {
        const response = await this.api("get", `/api/v1/promoter/race/${this.user.id}`);
        const { success, message } = response;
        if(success)
          this.listData = message.map((item) => {
          return {
            ...item,
            eventName: this.$escapeHtml.decode(item.eventName),
            raceName: this.$escapeHtml.decode(item.raceName),
            startDate: item.startDay,
            displayOnline: item.displayFlag ? 'Yes' : 'No',
            action: "<i class='far fa-pencil-alt'></i>"
          };
        });
      }
    } 
  },
  mounted() {
    this.loadRaceList();
  },
};
</script>

<style lang="scss">
</style>

